import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const schemaConfigSlice = createSlice({
	name: 'schemaConfig',
	initialState,
	reducers: {
		setSchemaConfig: (state, action) => {
			return action.payload;
		}
	}
});

export const { setSchemaConfig } = schemaConfigSlice.actions;
export default schemaConfigSlice.reducer;
